import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-871">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-872">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-873">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-874">
          {isOpen ? <XIcon size={24} data-id="element-875" /> : <PlusIcon size={24} data-id="element-876" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-877">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-878">
          {answer}
        </p>
      </div>
    </div>;
}
export function DFFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'Am I A Good Candidate For Dermal Fillers?',
    answer: 'Ideal candidates for dermal fillers are those in good health to restore volume loss in the cheeks or chin, improve fine lines or lip enhancement. Potential side effects like bruising and swelling are temporary and generally subside within two weeks. Results are visible immediately, with effects lasting at least six months, and sometimes up to two years.'
  }, {
    question: 'What Areas Can Be Treated?',
    answer: 'Dermal fillers can be used to treat various areas, including smile lines, marionette lines, lip lines, cheeks, under-eye hollows and lips. The specific treatment areas depend on individual concerns and goals.'
  }, {
    question: 'Is There Downtime After Treatment?',
    answer: 'Downtime is usually minimal, and many individuals resume normal activities immediately after the procedure. Some may experience mild swelling or bruising, but these effects typically subside within a few days.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-879">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-880">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-881">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-882">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-883"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-884">
          <div className="space-y-2" data-id="element-885">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-886" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}